import { Fragment, h } from "preact";
import { observer } from "mobx-react";
import { t, translate } from "../I18n";
import TextField from "./TextField";
import SelectField from "./SelectField";
import DeliveryAddressDivider from "./DeliveryAddressDivider";
import DeliveryFormItemWrapper from "./DeliveryFormItemWrapper";
function ApartmentInfoForm(props) {
    const { fieldId, controller } = props;
    switch (controller.type) {
        case "Default":
            return h(DefaultApartmentInfo, { fieldId: fieldId, controller: controller });
        case "Romanian":
            return (h(RomanianApartmentInfo, { fieldId: fieldId, controller: controller }));
    }
}
const DefaultApartmentInfo = observer((props) => {
    const { fieldId, controller } = props;
    const { fields } = controller;
    const fieldIds = {
        aptNumber: `${fieldId}.aptNumber`,
        floor: `${fieldId}.floor`,
    };
    return (h(Fragment, null,
        h(DeliveryFormItemWrapper, { name: "apt-number" },
            h(TextField, { name: fieldIds.aptNumber, dataFieldId: fieldIds.aptNumber, label: translate(t.activerecord.attributes.delivery_address.apt_number), controller: fields.aptNumber, required: false })),
        h(DeliveryFormItemWrapper, { name: "floor" },
            h(TextField, { name: fieldIds.floor, dataFieldId: fieldIds.floor, label: translate(t.activerecord.attributes.delivery_address.floor), controller: fields.floor, required: false }))));
});
const RomanianApartmentInfo = observer((props) => {
    const { fieldId, controller } = props;
    const { fields } = controller;
    const fieldIds = {
        sector: `${fieldId}.sector`,
        houseOrBlock: `${fieldId}.houseOrBlock`,
        block: `${fieldId}.block`,
        staircase: `${fieldId}.staircase`,
        floor: `${fieldId}.floor`,
        aptNumber: `${fieldId}.aptNumber`,
        interphone: `${fieldId}.interphone`,
        additionalInfo: `${fieldId}.additionalInfo`,
    };
    const houseOrBlockOptions = [
        {
            value: "House",
            label: translate(t.formtastic.labels.delivery_address.house),
        },
        {
            value: "Block",
            label: translate(t.formtastic.labels.delivery_address.block),
        },
    ];
    const isBlockAptInfo = fields.houseOrBlock.value === "Block";
    return (h(Fragment, null,
        h(DeliveryFormItemWrapper, { name: "sector" },
            h(TextField, { name: fieldIds.sector, dataFieldId: fieldIds.sector, label: translate(t.formtastic.labels.delivery_address.sector), controller: fields.sector, required: false })),
        h(DeliveryAddressDivider, null),
        h(DeliveryFormItemWrapper, { name: "house_or_block" },
            h(SelectField, { name: fieldIds.houseOrBlock, dataFieldId: fieldIds.houseOrBlock, label: translate(t.formtastic.labels.delivery_address.house_or_block), controller: fields.houseOrBlock, options: houseOrBlockOptions })),
        isBlockAptInfo && (h(Fragment, null,
            h(DeliveryAddressDivider, null),
            h(DeliveryFormItemWrapper, { name: "block" },
                h(TextField, { name: fieldIds.block, dataFieldId: fieldIds.block, label: translate(t.formtastic.labels.delivery_address.block), controller: fields.block, required: true })),
            h(DeliveryFormItemWrapper, { name: "staircase" },
                h(TextField, { name: fieldIds.staircase, dataFieldId: fieldIds.staircase, label: translate(t.formtastic.labels.delivery_address.staircase), controller: fields.staircase, required: true })),
            h(DeliveryAddressDivider, null),
            h(DeliveryFormItemWrapper, { name: "floor" },
                h(TextField, { name: fieldIds.floor, dataFieldId: fieldIds.floor, label: translate(t.activerecord.attributes.delivery_address.floor), controller: fields.floor, required: true })),
            h(DeliveryFormItemWrapper, { name: "apt-number" },
                h(TextField, { name: fieldIds.aptNumber, dataFieldId: fieldIds.aptNumber, label: translate(t.formtastic.labels.delivery_address.apt_number), controller: fields.aptNumber, required: true })),
            h(DeliveryAddressDivider, null),
            h(DeliveryFormItemWrapper, { name: "interphone" },
                h(TextField, { name: fieldIds.interphone, dataFieldId: fieldIds.interphone, label: translate(t.formtastic.labels.delivery_address.interphone), controller: fields.interphone, required: false })))),
        h(DeliveryAddressDivider, null),
        h(DeliveryFormItemWrapper, { name: "additionalInfo" },
            h(TextField, { name: "additionalInfo", dataFieldId: "fulfillmentMethod.deliveryAddress.additionalInfo", label: translate(t.formtastic.labels.delivery_address.additional_info), controller: fields.additionalInfo, required: false }))));
});
export default observer(ApartmentInfoForm);
